const headingFontFamily = '"Manrope", "Inter", "Roboto", "Helvetica", "Arial", sans-serif';

export default {
  fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  h1: {
    fontFamily: headingFontFamily,
    fontWeight: 800,
    fontSize: 35,
    letterSpacing: '-1px'
  },
  h2: {
    fontFamily: headingFontFamily,
    fontWeight: 800,
    fontSize: 29,
    letterSpacing: '-0.75px'
  },
  h3: {
    fontFamily: headingFontFamily,
    fontWeight: 700,
    fontSize: 24,
    letterSpacing: '-0.5px'
  },
  h4: {
    fontFamily: headingFontFamily,
    fontWeight: 700,
    fontSize: 20,
    letterSpacing: '-0.3px'
  },
  h5: {
    fontFamily: headingFontFamily,
    fontWeight: 700,
    fontSize: 16,
    letterSpacing: '-0.2px'
  },
  h6: {
    fontFamily: headingFontFamily,
    fontWeight: 700,
    fontSize: 14,
    letterSpacing: '-0.1px'
  },
  overline: {
    fontWeight: 500
  }
};
